import React from "react";
import Markup from "./markup/markup";

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Fonts
import "./css/vendor/line-awesome/css/line-awesome.min.css";
import "./css/vendor/font-awesome/css/all.min.css";
import "./css/vendor/themify/themify-icons.css";

// StyleSheet
import "./App.css";
import "./css/brand-overrides.css";

function App() {
  return (
    <div className="page-wraper overflow-x-hidden">
      <Markup />
    </div>
  );
}
export default App;
